var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAlert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Alert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Alert"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M10.9,12.9c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1h1.3c0.1,0,0.2,0,0.2-0.1 c0.1-0.1,0.1-0.1,0.1-0.2L13,9.2C13,9,13,9,12.9,8.9c-0.1-0.1-0.1-0.1-0.2-0.1H11c-0.1,0-0.2,0-0.2,0.1C10.7,9,10.6,9,10.6,9.2 L10.9,12.9z M11,14c-0.2,0.2-0.4,0.5-0.4,0.9c0,0.3,0.1,0.6,0.4,0.9c0.2,0.2,0.5,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4 c0.2-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9c-0.2-0.2-0.5-0.4-0.9-0.4C11.5,13.6,11.2,13.8,11,14z M19.7,16.9 c-0.1,0.3-0.2,0.6-0.4,0.8C19,17.8,18.7,18,18.4,18H5.3c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.4-0.5-0.4-0.8C4,16.6,4,16.3,4.2,16 l6.5-11.3c0.2-0.3,0.4-0.5,0.7-0.6C11.7,4,12,4,12.3,4.1c0.3,0.1,0.5,0.3,0.7,0.6L19.5,16C19.7,16.3,19.7,16.6,19.7,16.9z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-Alert.356387a6801158216398d6499fe0fb1f.svg";